declare namespace C2S {

    interface DataChangeInfo {
        type: string;
        entityId: any;
        entity: any;
    }

}